import { render, staticRenderFns } from "./OutletIcon.vue?vue&type=template&id=03989614"
import script from "./OutletIcon.vue?vue&type=script&lang=js"
export * from "./OutletIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports